import {  Routes, Route } from "react-router";
import { BrowserRouter } from 'react-router-dom';
import Home from "./Pages/Home";



function App() {
  return (
      <BrowserRouter future={{ v7_startTransition: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
